/* eslint-disable react/jsx-no-useless-fragment */
import { bool, func, object, string } from 'prop-types'
import React, { Fragment } from 'react'
import Loader from '@taglivros/oef_componentes/build/components/loader'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

import styled from 'styled-components'
import { BANDEIRAS_IMAGES } from '../../constants'
import { isEmptyObject, objetoTemPropriedade } from '../../utils/helpers/helpers'

const estiloBandeiraMobile = `
  height: 30px;
  margin-right: 7px;
  max-width: 39px;
`

const cartaoBordaMobile = `
  padding-right: 0;
`

const CartaoBorda = styled.div`
  background-color: ${StyleGuide.cores.branco};
  ${( { resumido } ) => !resumido && `border: 1px solid ${StyleGuide.cores.cinza200}`};
  border-radius: 5px;
  ${( { cor, selecionado } ) => selecionado && `box-shadow: 0px 0px 0px 2px ${cor};`}
  box-sizing: border-box;
  color: ${StyleGuide.cores.cinza500};
  font-family: 'Noto Sans Display', sans-serif;
  margin: ${( { margin } ) => margin};
  ${( { maxWidth } ) => maxWidth && `max-width: ${maxWidth};`}
  ${( { desativado } ) => desativado && `opacity: 0.5`};
  padding: ${( { resumido } ) => resumido ? `5px 0` : `22px 30px`};
  padding-right: 46px;
  transition: all ease 0.3s;

  &:hover {
    ${( { cor, hover, resumido } ) => hover && !resumido && `box-shadow: 0px 0px 0px 2px ${cor};`}
  }

  @media( max-width: ${StyleGuide.mediaQuery.smallpc} ) {
    padding-right: 26px;
  }

  @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
    ${( { mobile } ) => mobile && cartaoBordaMobile}
  }

  @media( min-width: ${StyleGuide.mediaQuery.mobile} ) and (max-width: ${StyleGuide.mediaQuery.tablet} ) {
    ${( { mobile } ) => mobile && `width: 50%`};
  }

  .cartao__bandeira {
    background-image: url( ${( { bandeira } ) => bandeira && bandeira} );
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    border: ${( { resumido } ) => resumido ? `none` : `1px solid ${StyleGuide.cores.cinza200};`};
    border-radius: 5px;
    height: 43px;
    margin-bottom: ${( { resumido } ) => resumido ? `0px` : `5px`};
    margin-right: 21px;
    max-width: 62px;
    width: 100%;

    ${( { mobile } ) => mobile && estiloBandeiraMobile}
  }
`

const CartaoLinhaCima = styled.div`
  align-items: ${( { resumido } ) => resumido ? `center` : `left`};
  display: flex;
  flex-direction: ${( { resumido } ) => resumido ? `row` : `column`};
  margin-bottom: ${( { resumido } ) => resumido ? `16px` : `0px`};
  ${StyleGuide.tipografia.textoGrande};
  justify-content: space-between;
  ${( { mobile } ) => mobile && `margin-bottom: 0px;`}
  width: 100%;

  @media( min-width: ${StyleGuide.mediaQuery.tablet} ) and (max-width: ${StyleGuide.mediaQuery.smallpc} ) {
    flex-wrap: wrap;
    margin: 20px 0 0;
  }
`

const CartaoNumero = styled.p`
  display: inline-flex;
  font-size: ${( { resumido } ) => resumido ? `16px` : `18px`};
  margin: 10px 0;
  text-align: justify;
  width: 100%;

  .numero {
    margin-right: 12px;
    letter-spacing: 1px;
  }
`

const CartaoLinhaBaixo = styled.div`
  align-items: center;
  display: flex;
  ${StyleGuide.tipografia.textoGrande};
  justify-content: space-between;
  width: 100%;
`

const CartaoNome = styled.p`
  ${( { mobile } ) => mobile && `${StyleGuide.tipografia.textoDefault};`};
  margin: 0;

  @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
    ${( { mobile } ) => mobile && `margin-top: 0;`};
  }
`

const cartaoVencimentoMobile = `
  ${StyleGuide.tipografia.textoHelper};
`

const CartaoVencimento = styled.p`
  ${( { mobile } ) => mobile && cartaoVencimentoMobile};
  margin: 0;

  @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
    ${( { mobile } ) => mobile && `margin-top: 0;`};
  }

  small {
    display: block;
    ${StyleGuide.tipografia.textoHelper};
    color: ${StyleGuide.cores.cinza300};
  }
`

const WrapperLoader = styled.div`
  margin: 30px auto;
`

const CartaoCredito = ( {
  cartao,
  corBorda,
  desativado,
  hover,
  id,
  infoNumerica,
  margin,
  maxWidth,
  mobile,
  onClick,
  resumido,
  selecionado,
  esconderVencimento
} ) => {
  const cartaoTemPropriedadesValidade = !isEmptyObject( cartao ) && objetoTemPropriedade( cartao, 'mes_validade' ) && objetoTemPropriedade( cartao, 'ano_validade' )
  const validadeCartaoFormatada = cartaoTemPropriedadesValidade && cartao.mes_validade && cartao.ano_validade ? `${cartao.mes_validade}/${cartao.ano_validade && cartao.ano_validade.toString().substring( 2, 4 )}` : cartao.validade
  const ultimosDigitos = objetoTemPropriedade( cartao, 'ultimosDigitos' ) ? cartao.ultimosDigitos : cartao.ultimos_digitos
  return (
    <Fragment>
      { cartao ?
        <CartaoBorda
          bandeira={ cartao ? BANDEIRAS_IMAGES[ cartao.bandeira ] : null }
          cor={ corBorda }
          data-e2e-id={ id }
          desativado={ desativado }
          hover={ hover }
          margin={ margin }
          maxWidth={ maxWidth }
          mobile={ mobile }
          onClick={ onClick }
          resumido={ resumido }
          selecionado={ selecionado }
        >
          <CartaoLinhaCima
            margin={ margin }
            mobile={ mobile }
            resumido={ resumido }
          >
            <div
              className="cartao__bandeira"
              // eslint-disable-next-line react/no-unknown-property
              mobile={ mobile ? mobile : null }
            />

            <CartaoNumero
              resumido={ resumido }
            >
              <span className="numero">
                ••••
              </span>

              <span className="numero">
                ••••
              </span>

              <span className="numero">
                ••••
              </span>

              <span className="numero">
                { ultimosDigitos }
              </span>
            </CartaoNumero>
          </CartaoLinhaCima>

          { !infoNumerica &&
            <CartaoLinhaBaixo>
              <CartaoNome mobile={ mobile }>
                { cartao.nome }
              </CartaoNome>

              { validadeCartaoFormatada && !esconderVencimento ?
                <CartaoVencimento mobile={ mobile }>
                  <small>
                    Vencimento
                  </small>

                  { validadeCartaoFormatada }
                </CartaoVencimento> : null}
            </CartaoLinhaBaixo>}
        </CartaoBorda> :
        <WrapperLoader>
          <Loader isCenter />
        </WrapperLoader>}
    </Fragment>
  )
}

CartaoCredito.propTypes = {
  'cartao': object.isRequired,
  'corBorda': string,
  'desativado': bool,
  'esconderVencimento': bool,
  'hover': bool,
  'id': string,
  'infoNumerica': bool,
  'margin': string,
  'maxWidth': string,
  'mobile': bool,
  'onClick': func,
  'resumido': bool,
  'selecionado': bool
}

CartaoCredito.defaultProps = {
  'corBorda': StyleGuide.cores.azul,
  'desativado': false,
  'esconderVencimento': false,
  'hover': true,
  'id': '',
  'infoNumerica': false,
  'margin': '',
  'maxWidth': '',
  'mobile': false,
  'onClick': () => {},
  'resumido': false,
  'selecionado': false
}

export default CartaoCredito
